import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IpExclusionsState } from './ip-exclusions.reducer';

export const selectIpExclusionsState =
  createFeatureSelector<IpExclusionsState>('ipExclusions');

export const selectIpExclusions = createSelector(
  selectIpExclusionsState,
  (state) => state.ipExclusions
);
export const selectIpExclusionsMeta = createSelector(
  selectIpExclusionsState,
  (state) => state.meta
);
export const selectIpExclusionsStatistics = createSelector(
  selectIpExclusionsState,
  (state) => state.statistics
);
export const selectIpExclusionsTotal = createSelector(
  selectIpExclusionsState,
  (state) => state.meta?.total ?? 0
);
export const selectSingleIpExclusion = createSelector(
  selectIpExclusionsState,
  (state) => state.singleIpExclusion
);
export const selectIpExclusionDuplicateUuid = createSelector(
  selectIpExclusionsState,
  (state) => state.duplicateUuid
);
export const selectIpExclusionsLoading = createSelector(
  selectIpExclusionsState,
  (state) => state.isLoading
);
export const selectIpExclusionsSubmitting = createSelector(
  selectIpExclusionsState,
  (state) => state.isSubmitting
);
export const selectIpExclusionsDeleting = createSelector(
  selectIpExclusionsState,
  (state) => state.isDeleting
);
export const selectIpExclusionsBulkDeleting = createSelector(
  selectIpExclusionsState,
  (state) => state.isBulkDeleting
);
export const selectIpExclusionsImporting = createSelector(
  selectIpExclusionsState,
  (state) => state.isImporting
);
export const selectIpExclusionLoadingSingle = createSelector(
  selectIpExclusionsState,
  (state) => state.isLoadingSingle
);
export const selectIpExclusionsError = createSelector(
  selectIpExclusionsState,
  (state) => state.error
);
export const selectIpExclusionsLastQuery = createSelector(
  selectIpExclusionsState,
  (state) => state.lastQuery
);
